(function(){

    angular.module('tmx-app').controller('roleManagementCtrl', ['$scope','menu','$state','RoleManagementService',
        'tmxUtility','$mdSidenav','CurrentUserService','TmxDialogService','ServerExceptionService','ToastService',
    
        function RoleManagementCtrl($scope,menu, $state,RoleManagementService,tmxUtility,$mdSidenav,
            CurrentUserService,TmxDialogService,ServerExceptionService,ToastService){
            var exists;
            var copy;
            var roleManagementVM=this;
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
            roleManagementVM.checkPermission = tmxUtility.checkPermission;
            roleManagementVM.menu=menu;
            roleManagementVM.isPageLoading = false;

            roleManagementVM.editPermission = roleManagementVM.checkPermission('Private.Administration.RoleManagement','Edit') ;

            roleManagementVM.viewPermission = roleManagementVM.checkPermission('Private.Administration.RoleManagement','View');
 

            
        ////////////  WATCHING FOR CHANGES IN THE ERROR when Deactivate/////////////////////////////////////
            $scope.$watch(function () { return ServerExceptionService.Displaymsg}, function (newVal, oldVal) {
                if($scope.watch_count > 1) {
                    return;
                }

                if (typeof newVal !== 'undefined' && $scope.watch_count == 1) {
                    $scope.error = ServerExceptionService.Displaymsg;

                    $scope.watch_count = $scope.watch_count+1;
                    ServerExceptionService.Displaymsg = oldVal;//to differentiate old value from new value when user signs
                // in multiple time using incorrect username and password and the server returns the same error
                    $scope.$on("$destroy", function(){
                        ServerExceptionService.Displaymsg = "";
                    });
                }
            });
  ///////////////////////////////DISABLE ADD ICON WHEN SIDENAV IS OPEN////////////////////////////////////////////////
            roleManagementVM.checkAddDisabled = function(){
                if($mdSidenav(roleManagementVM.nav).isOpen()){
                    return true;
                }
                else{
                    return false;
                }
            };
/////////////////////////////////////////INITIALIZATIONS////////////////////////////////////////////////////////////////
 /////////////////////////GETTING CURRENT TENANT ///////////////////////////////////////////////////////////////////////
            roleManagementVM.currentTenant  = CurrentUserService.getUserObject();
 ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            roleManagementVM.gridData = {  data: new kendo.data.ObservableArray([])};
            roleManagementVM.dataLoading = true;
            roleManagementVM.date = tmxUtility.setEndDate(new Date()).toJSON(); //used in isStatusActive()
            roleManagementVM.RoleManagementService = RoleManagementService;
            roleManagementVM.nav = "SearchSideNav";
            roleManagementVM.searchSideNavActive = false;
            roleManagementVM.exportSideNavActive = false;
            roleManagementVM.gridColumns = RoleManagementService.columns;
            roleManagementVM.filterColumns = RoleManagementService.filterColumns;


///////////////////////////////////*******************KENDO START*********************//////////////////////////////////////
  /////////////////////////// FILTERED FUNCTION TO APPLY FA-FILTER ICON on SEARCH RESULTS///////////////////////////////
            roleManagementVM.isFiltered=function(fieldName){
                var filtered = false;
                if(fieldName == "Status"){
                    fieldName="EffectiveEndDate";
                }
                if(angular.isDefined(roleManagementVM.filters)){
                    roleManagementVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName){
                            filtered = true;
                        }
                    });
                }
                return filtered;
            };
            
////////////////////////////////////////////////BUILDING THE GRID////////////////////////////////////////////////////            
            roleManagementVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o){
                            if(angular.isDefined(roleManagementVM.searchClear) && roleManagementVM.searchClear==false){
                                if(exists(roleManagementVM.o)){
                                    copy(roleManagementVM.o.data,["filter"],o.data);
                                }
                            }
                            roleManagementVM.searchClear = false;
                            if(roleManagementVM.onChildState()){return;}
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    roleManagementVM.searchClear = true;
                                    $state.searchClear=undefined;
                                //return;
                                }
                            //if(exists(roleManagementVM.o))
                            //    copy(roleManagementVM.o.data,["filter"],o.data);
                            }
                            else
                                o.data.firstPage = true;
                            roleManagementVM.o = angular.copy(o); //to be forwarded as model to the sideNav search directive

                            roleManagementVM.filters = roleManagementVM.o.data.filter;
                            roleManagementVM.isPageLoading = true;
                            RoleManagementService.getByParams(o,true).then(function(response){
                                roleManagementVM.dataLoading = false;
                                parseResppnse(response.data);
                                roleManagementVM.excelData=response;
                                o.success(response); //full response returned
                                roleManagementVM.isPageLoading = false;
                            });
                        },
                        dataType: "application/json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort:  [{field: "CreatedDate", dir: "desc"}/*,{field: "CreatedDate", dir: "desc"}*/]
                },
                excelExport: function(e) {                              
                    var sheet = e.workbook.sheets[0];
                    var data = roleManagementVM.excelData.data;
                    var gridColumns = roleManagementVM.container.roleGrid.columns;                    
                    var columns = tmxUtility.columnsMapping(gridColumns);                    
                    var rows=tmxUtility.dataMapping(data,columns);                    
                    sheet.rows = rows;                                                                  
                }, 
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "Roles.pdf"
                },
                excel: {
                    // allPages: true,
                    fileName: "Roles.xlsx"
                },
                sortable: {
                    mode: "single",
                    allowUnsort: true
                },
                scrollable: false,
                rowTemplate: kendo.template($("#rowTemplate").html()),
                columns: roleManagementVM.gridColumns
            };
     //////////INITIALIZING THE $state.data for access to grid in Edit.js///////////////////////////////////////////////
            roleManagementVM.container = {};//defining the object for grid access in controller
            $state.data= {
                grid: roleManagementVM.container,
                mainGridOptions: angular.copy(roleManagementVM.mainGridOptions)
            };
///////////////////////////////////*******************KENDO END*********************////////////////////////////////////

/////////////////////////////////////*************Functions START****************///////////////////////////////////////
/////////////////////////////////////////CHECK IF ON CHILD STATE (ADD/EDIT)/////////////////////////////////////////////
            roleManagementVM.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            };
//////////////////////////////////////////////////////GO TO ADD STATE///////////////////////////////////////////////////
            roleManagementVM.new = function(){
            //roleManagementVM.searchClear = true;
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".add");
            };
///////////////////////////////////////////////GO TO EDIT CHILD STATE///////////////////////////////////////////////////
            roleManagementVM.clickEdit = function (item) {
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{"Id":item.RoleId});
            };
//////////////////////////////////////////////GO TO VIEWCHILD STATE///////////////////////////////////////////////////
            roleManagementVM.clickView = function (item) {
                $state.data.info = true;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{"Id":item.RoleId});
            };
/////////////////////////////////////////////////CLICK ROLE ACTIVATE: DIALOG APPEARS////////////////////////////////////
            roleManagementVM.clickActivate = function(item) {
                var diagConfig={
                    action:"Activate",
                    entity:"Role",
                    entityname:item.RoleName,
                    details:[
                        {value:item.RoleName,label:"Role Name"},
                        {value:item.Status, label:"Status"}
                    ],
                    options:[
                        {label:"Activate",value:true,class:"md-warn"},
                        {label:"Cancel",value:false,class:"md-primary"}
                    ]
                };
                function callback(ok) {
                    if(ok){
                        roleManagementVM.Activate(item);
                    }
                }
                var roleActivateDialog=new TmxDialogService.confirmDialog(diagConfig,callback);
                roleActivateDialog.show();

            };
////////////////////////////////////ROLE ACTIVATE///////////////////////////////////////////////////////////////////////
            roleManagementVM.Activate = function(item){
                RoleManagementService.prototype.$activate(item.RoleId).then(function() {

                    roleManagementVM.container.roleGrid.dataSource.read();

                });
            };
////////////////////////////////CLICK ROLE DEACTIVATE: DIALOG APPEARS///////////////////////////////////////////////////
            roleManagementVM.clickDeactivate = function(item) {

                var diagConfig={
                    action:"Deactivate",
                    entity:"Role",
                    entityname:item.RoleName,
                    details:[
                        {value:item.RoleName,label:"Role Name"},
                        {value:item.Status, label:"Status"}
                    ],
                    options:[
                        {label:"Deactivate",value:true,class:"md-warn"},
                        {label:"Cancel",value:false,class:"md-primary"}
                    ]
                };
                function callback(ok) {
                    if(ok){

                        roleManagementVM.Deactivate(item);
                    }
                }
                var myDialog=new TmxDialogService.confirmDialog(diagConfig,callback);

                $scope.watch_count = 1;
                RoleManagementService.getById(item.RoleId).then(function(data){
            
                    if(data.data.TmXUserRoleMapping.length > 0){
                        ToastService.showCustomToast("error","Please remove associated Users before deactivating this Role");
                    }
                    else{
                        myDialog.show();
                    }
                });
            };
/////////////////////////////////////ROLE DEACTIVATE////////////////////////////////////////////////////////////////////
            roleManagementVM.Deactivate = function(item) {
            //function from tmxResource
             
                RoleManagementService.prototype.$deactivate(item.RoleId).then(function() {

                    roleManagementVM.container.roleGrid.dataSource.read();

                });
            };
/////////////////////////////////////////////////CHECK IF ROLE ACTIVE OR DEACTIVE///////////////////////////////////////
            roleManagementVM.isStatusActive = function(dataitem) {
             
                if (dataitem == "Active" || dataitem == "Pending" )
                    return true;

                else
                    return false;
            };
     /////////////////////////////GET ROLE STATUS ACCORDING TO EFFECTIVE END AND START DATE/////////////////////////////
            roleManagementVM.getStatus = function(dataitem) {
                return dataitem.Status;

            };          
   ///////////////////////////////**********kendo row template functions************////////////////////////////////////
//////////////////////////MAIN GRID RoleName COL 1 row template display function///////////////////////////////////////
            roleManagementVM.formatRoleName=function(dataitem) {
                return tmxUtility.sliceText(dataitem,25);
            };
////////////////////MAIN GRID Role Description COL 2 row template display function/////////////////////////////////////
            roleManagementVM.formatRoleDescription=function(dataitem) {
                if(exists(dataitem)){
                    return tmxUtility.sliceText(dataitem,100);
                }
                else
                {
                    return '';
                }
            };
////////////////////MAIN GRID Users Assigned COL 4 row template display function/////////////////////////////////////
            roleManagementVM.getUsers=function(dataitem) {
                return dataitem.UserCount;
            };

///////////////////////////////***************************************************//////////////////////////////////////


////////////////////////////////////////SIDE NAV SEARCH////////////////////////////////////////////////////////////////
/////////////////////////SIDE NAV EXPORT/SEARCH MENU CHECK IF OPEN//////////////////////////////////////////////////////
            roleManagementVM.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };
//////////////////////////SIDE NAV SEARCH ICON CLICK FUNCTION///////////////////////////////////////////////////////////
            roleManagementVM.toggleSearch = function() {

                if (roleManagementVM.searchSideNavActive) {
                    roleManagementVM.searchSideNavActive = false;
                }
                else{
                    roleManagementVM.searchSideNavActive = true;
                }
                roleManagementVM.toggle('SearchSideNav');
            };
//////////////////////////SIDE NAV SEARCH ICON CLICK FUNCTION///////////////////////////////////////////////////////////
            roleManagementVM.toggleExport = function() {
                if (roleManagementVM.exportSideNavActive)
                    roleManagementVM.exportSideNavActive = false;
                else
                    roleManagementVM.exportSideNavActive = true;
                roleManagementVM.toggle('ExportSideNav');
            };
/////////////////////////SIDE NAV SEARCH/EXPORT TOGGLE/////////////////////////////////////////////////////////////////////////
            roleManagementVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function(){
                    });
            };

            function parseResppnse(data){
                data.forEach(function(dataItem){                                        
                    dataItem.RoleName = roleManagementVM.formatRoleName(dataItem.RoleName);
                    dataItem.statusActive=roleManagementVM.isStatusActive(dataItem.Status);
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);
                    dataItem.RoleDescription=roleManagementVM.formatRoleDescription(dataItem.RoleDescription);
                    
                });
            }

        }]);//management function end
})();

